import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "navbar-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.status")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.status,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "status", $$v);
      },
      expression: "value.status"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.textColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textColor", $$v);
      },
      expression: "value.textColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.hoverTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "hoverTextColor", $$v);
      },
      expression: "value.hoverTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.stickyShow"),
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.open"),
      "un-checked-children": _vm.$t("form.close")
    },
    model: {
      value: _vm.value.float,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "float", $$v);
      },
      expression: "value.float"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.logoWidth"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 340,
      suffix: "px"
    },
    model: {
      value: _vm.value.logoWidth,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "logoWidth", $$v);
      },
      expression: "value.logoWidth"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.paddingTop"),
      layout: "vertical",
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcPaddingTop,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcPaddingTop", $$v);
      },
      expression: "value.pcPaddingTop"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.paddingBottom"),
      layout: "vertical",
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcPaddingBottom,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcPaddingBottom", $$v);
      },
      expression: "value.pcPaddingBottom"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.elementSet")
    }
  }, [_c("CardItem", {
    attrs: {
      title: "LOGO",
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "logo", $$v);
      },
      expression: "value.logo"
    }
  })], 1), _c("a-row", [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: function success(val) {
        return _vm.handleLogoSuccess(val);
      },
      delete: _vm.handleClearImg
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.logoWidth"),
      layout: "vertical",
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 340,
      suffix: "px"
    },
    model: {
      value: _vm.value.logoWidth,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "logoWidth", $$v);
      },
      expression: "value.logoWidth"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.langButton")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.lang,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "lang", $$v);
      },
      expression: "value.lang"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.searchButton"),
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.search,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "search", $$v);
      },
      expression: "value.search"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.accountButton"),
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.account,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "account", $$v);
      },
      expression: "value.account"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.cartButton"),
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.shopcart,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "shopcart", $$v);
      },
      expression: "value.shopcart"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };